module.exports = __webpack_public_path__ + "static/img/AmwayIcons.dff48a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/affiliatecard/font/AmwayIcons.svg?5v2gxx
// module id = C9Bf
// module chunks = 0